import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders an image from the docroot/themes/custom/luminis/images folder.
 */
const Image = ({ fileName, className, alt }) => {
  const path = `/themes/custom/luminis/images/${fileName}`;
  return (
    <img src={path} className={className} alt={alt} />
  );
}

Image.propTypes = {
  /**
   * the file name for the image
   */
  fileName: PropTypes.string.isRequired,
  /**
   * any classes you'd like to add to the image
   */
  className: PropTypes.string,
  /**
   * the alternative text of the image
   */
  alt: PropTypes.string.isRequired,
};

export default Image;
